

























































































































import { Component, Vue } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import OrganizationMemberInviteMenu from '@/components/organizationConfig/configList/InviteOrganizationMember.vue';
import { vxm } from '@/store';
import { InviteOrganizationMemberDto,OrganizationMember,CreateOrganizationResult } from '@/@types/Organization';
import { PaymentUnitDivision } from '@/@types/masterData';
import { ORGANIZATION_BILLING_PLAN, PLAN_LIMIT } from '@/@types/constant';

@Component({
  components: {
    AccountIcon,
    CommonButton,
    OrganizationMemberInviteMenu,
  },
})
export default class OrganizationMembers extends Vue {
  private isOpenOrganizationMemberInviteMenu = false;
  private organizationMembers: OrganizationMember[] = [];
  private paymentUnitDivisions: PaymentUnitDivision[] | undefined = undefined;
  private selectedOrganization: CreateOrganizationResult | undefined = undefined ;
  private availablesToAdd:string = '0';
  private inputKeyword:string = '';
  private countOfMembers:number = 0;
  private countOfGeneralUsers:number = 0;
  private countOfInvitings:number = 0;

  private async created() {
    const userInfo = vxm.theoryApi.authStore.getCurrentUserInfo?.results;
    await vxm.theoryApi.organizationsStore.fetchOrganizationMembers({organizationId:userInfo?.organizationId!, findKeyword:''})
    this.organizationMembers = vxm.theoryApi.organizationsStore.getOrganizationMembers;
    this.paymentUnitDivisions = vxm.theoryApi.mastersStore.getPaymentUnitDivision;
    await vxm.theoryApi.organizationsStore.findOneOrganization(vxm.theoryApi.authStore.getCurrentOrganizationId!);
    this.selectedOrganization = vxm.theoryApi.organizationsStore.getOrganization;
    this.countOfMembers = this.organizationMembers.length;
    this.countOfGeneralUsers = this.organizationMembers.filter(x => x.organizationAdministratorFlag === 0).length;
    this.updateAvailablesToAdd();
  }

  private openOrganizationMemberInviteMenu() {
    this.isOpenOrganizationMemberInviteMenu = true;
  }

  private closeOrganizationMemberInviteMenu() {
    this.isOpenOrganizationMemberInviteMenu = false;
  }

  private async inviteOrganizationMember(inviteOrganizationMemberDto: InviteOrganizationMemberDto) {
    await vxm.theoryApi.organizationsStore.inviteOrganizationMember(inviteOrganizationMemberDto);
    this.isOpenOrganizationMemberInviteMenu = false;
  }

  private async changeToAdmin(organizationMemberId: number) {
    await vxm.theoryApi.organizationsStore.updateOrganizationMember({
      organizationMemberId: organizationMemberId,
      organizationId: vxm.theoryApi.authStore.getCurrentOrganizationId ?? 0,
      organizationAdministratorFlag: true,
    })
  }

  private async changeToGeneral(organizationMemberId: number) {
    await vxm.theoryApi.organizationsStore.updateOrganizationMember({
      organizationMemberId: organizationMemberId,
      organizationId: vxm.theoryApi.authStore.getCurrentOrganizationId ?? 0,
      organizationAdministratorFlag: false,
    })
  }

  private getPaymentUnitName(paymentUnitCd: string) {
    if (this.paymentUnitDivisions) {
      const result = this.paymentUnitDivisions.find(x => x.paymentUnitDivisionCd === paymentUnitCd);
      if (result) {
        return result.paymentUnitDivisionName
      }
    }
    return paymentUnitCd;
  }

  private updateAvailablesToAdd() {
    if (this.selectedOrganization) {
      switch (this.selectedOrganization.billingPlan) {
        case ORGANIZATION_BILLING_PLAN.FREE:
          this.availablesToAdd = (PLAN_LIMIT.FREE.ORGANIZATION_MEMBER - this.organizationMembers.length).toString();
          break;
        case ORGANIZATION_BILLING_PLAN.STANDARD:
          this.availablesToAdd = (PLAN_LIMIT.STANDARD.ORGANIZATION_MEMBER - this.organizationMembers.length).toString();
          break;
        default:
          this.availablesToAdd = '上限なし'
      }
    }
  }

  private findMember() {
    const userInfo = vxm.theoryApi.authStore.getCurrentUserInfo?.results;
    vxm.theoryApi.organizationsStore.fetchOrganizationMembers({organizationId:userInfo?.organizationId!,findKeyword:this.inputKeyword}).then(() => {
      this.organizationMembers = vxm.theoryApi.organizationsStore.getOrganizationMembers;
    });
  }
}
